import { createAction } from '@reduxjs/toolkit';
import { Message } from '../models/Message';

export const putMessages = createAction<Message[]>('PUT_MESSAGES');
export const deleteMessage = createAction<string>('DELETE_MESSAGE');
